import MultipleSelect from './MultipleSelect';

export default MultipleSelect;